import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { deleteCarouselImage, CAROUSEL_QUERY_KEY } from "./api";

interface DeleteCarouselImageParams {
  venuePageId: string;
  imageId: string;
}

/**
 * Hook to delete an image from the carousel
 */
export function useDeleteCarouselImage(): UseMutationResult<
  { success: boolean },
  Error,
  DeleteCarouselImageParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ venuePageId, imageId }: DeleteCarouselImageParams) =>
      deleteCarouselImage(venuePageId, imageId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [CAROUSEL_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
